import api from "../Api";
import { BaseService } from "../BaseService";

const URL = "chats/messages";

export class ChatsFeedbackAnalysisService extends BaseService {
  async list(params: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/vote`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async fetch(params: any): Promise<any> {
    try {
      return this.handleResponse(
        await api.put(`${URL}/vote/${params.vote_id}/status`, params)
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}
